// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Disable right-click and dev tools in production
// if (process.env.NODE_ENV === "production") {
//   document.addEventListener("contextmenu", (e) => e.preventDefault());
//   document.addEventListener("keydown", (e) => {
//     if (
//       e.keyCode === 123 ||
//       (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||
//       (e.ctrlKey && e.keyCode === 85)
//     ) {
//       e.preventDefault();
//     }
//   });
// }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
